{
  "notFound": {
    "title": "PAGE NOT FOUND",
    "msg": "We're sorry, the page you requested could not be found.",
    "goHomeBtn": "Go Homepage"
  },
  "notAvailable": {
    "title": "PAGE NOT AVAILABLE",
    "msg": "We're sorry, the page you requested is not available."
  },
  "validatorService": {
    "minLength": "Minimum characters allowed:",
    "maxLength": "Maximum characters allowed",
    "required": "Required field",
    "invalidEmail": "Invalid email"
  },
  "header": {
    "configurationMenu": {
      "accountSettings": "Account settings",
      "eventId": "QR - ID",
      "MyBooking": "My Booking",
      "myCertificates": "My Certificates",
      "surveys": "Surveys",
      "courses": "Courses"
    }
  },
  "event-id-qr": {
    "title": "EVENT ID",
    "ticket-label": "Ticket type",
    "noData": "You dont have a QR ID for this event",
    "error": {
      "title": "Error in QR ID",
      "message": "We sorry, we couldn't query the QR data"
    }
  },
  "welcome": {
    "title": "Welcome to",
    "event": "Event Management system"
  },
  "login": {
    "loginTitle": "Login",
    "logout": "Logout",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "rememberMe": "Remember me",
    "loginButton": "LOGIN",
    "forgotPassword": "Forgot password?",
    "passwordLabelConfirm": "Confirm password",
    "signUp": "Sign Up",
    "or": "or",
    "signIn": "Sign In!",
    "signUpSocial": "Sign up with your social media account or email address",
    "signInSocial": "Sign in with your social media account or email address",
    "errorsLogin": {
      "invalidEmail": {
        "title": "Invalid email",
        "message": "We couldn't authenticate you due to your email is invalid"
      },
      "userNotFound": {
        "title": "User not found",
        "message": "Verify your email or password and try again."
      },
      "wrongPassword": {
        "title": "Wrong password or email",
        "message": "We coulan't authenticate you, verify your email or password and try again."
      },
      "accountExistsDifferentCredential": {
        "title": "Account exists with different credential",
        "message": "We couldn't authenticate you due to this credential is already used by another email account."
      },
      "operationNotAllowed": {
        "title": "Operation not allowed",
        "message": "This functionality is not allowed to login"
      },
      "userDisabled": {
        "title": "User disabled",
        "message": "We couldn't authenticate you due to your account seems to be deactivated"
      },
      "invalidVerificationID": {
        "title": "Invalid verification ID",
        "message": "We couldn't authenticate you due to you don't have a valid ID"
      },
      "domainConfigRequired": {
        "title": "Domain config required",
        "message": "The configuration of the auth domain has not been setted up"
      },
      "popupCancelled": {
        "title": "Cancelled popup request",
        "message": "We couldn't authenticate you due to multiple tabs of the login have been opened, please close them and try again"
      },
      "operationNotSupported": {
        "title": "Operation not supported",
        "message": "We couldn't authentiate you due to this action is not suported by security protocols"
      },
      "popupBlocked": {
        "title": "Popup blocked",
        "message": "We couldn't authenticate you due to the browser blocked the login popup"
      },
      "popupClosed": {
        "title": "Popup closed by user",
        "message": "We couldn't authenticate you due to you closed the login popup"
      },
      "unauthorizedDomain": {
        "title": "Unauthorized domain",
        "message": "Domain not authorized to login"
      },
      "providerAlreadyLinked": {
        "title": "Provider already linked",
        "message": "Register error due to this provider is already linked with another user"
      },
      "invalidCredential": {
        "title": "Invalid credential",
        "message": "Register error due to invalid credentials"
      },
      "credentialAlreadyUsed": {
        "title": "Credential already in use",
        "message": "Register error due to user already registered"
      },
      "invalidVerificationCode": {
        "title": "Invalid verification code",
        "message": "Register error due to your verification code is not valid."
      },
      "emailAlreadyUsed": {
        "title": "Email already in use",
        "message": "Register error due to this email account is already registered."
      },
      "weakPassword": {
        "title": "Weak password",
        "message": "Register error due to a weak password"
      },
      "defaultError": {
        "title": "Something went wrong",
        "message": "Something went wrong with error code:"
      }
    }
  },
  "drawer": {
    "alreadyAccount": "Already have an account?",
    "register": "Register",
    "home": "Home",
    "welcomeMessage": "Welcome Message",
    "speakers": "Speakers",
    "hotelBooking": "Hotel Booking",
    "program": "Program",
    "abstracts": "Abstracts",
    "expo": "Expo",
    "contact": "Contact",
    "checkout": "Checkout"
  },
  "home": {
    "seats": "Seats",
    "greatsSpeakers": "Greats speakers",
    "noLocation": "No Location",
    "time": {
      "days": "Days",
      "hours": "Hours",
      "minutes": "Minutes",
      "seconds": "Seconds"
    },
    "homeView": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    }
  },
  "register": {
    "title": "Choose a category",
    "browseImage": "BROWSE PROFILE PICTURE",
    "changeImage": "CHANGE IMAGE",
    "registration": "Registration",
    "register": "Register",
    "fullName": "Full name",
    "firstName": "First name",
    "lastName": "Last name",
    "secondLastName": "Second last name",
    "email": "E-mail",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "ticketType": "Ticket type",
    "submit": "Submit",
    "disabledForm": "Button disabled, please fill all the required fields",
    "passwordDontMatch": "Passwords don't match please try again",
    "eventInfo": "Event Info",
    "genderTitle": "Gender",
    "birthday": "Birthday",
    "accountComplete": "Complete your Account",
    "continuePayment": "Continue to payment",
    "eventHasEnded": "The registration time for the event has ended.",
    "ticketsNotAvailable": "Tickets not currently available.",
    "profileImageSizeError": {
      "title": "Size too big",
      "message": "The image has to be minor to 500kb"
    },
    "gender": {
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "payment": {
      "payment": "Payment",
      "yourTicket": "Your ticket",
      "pay": "Pay",
      "register": "Register",
      "registerTitle": "Registration ",
      "registerMessage": "To continue with your registration, click on the registration button.",
      "nameCard": "Name of card",
      "cardNumber": "Card number",
      "expirationDate": "Expiration date",
      "paymentDialogTitle": "Provide your card details",
      "errorMessages": {
        "incompleteNumber": "Card number incomplete",
        "invalidNumber": "Invalid card number",
        "incomplateExpiry": "Incomplete card expiry",
        "invalidExpiry": "Invalid  card expiry",
        "incompleteCvc": "Incomplate CVC"
      }
    },
    "registerError": {
      "title": "Something went wrong",
      "message": "It wasn't possible to register the participant"
    },
    "paymentError": {
      "title": "Something went wrong",
      "message": "It wasn't possible to complete the payment"
    },
    "paymentErrorQuota": {
      "title": "Something went wrong",
      "message": "Tickets not currently available"
    },
    "paymentSuccess": {
      "title": "Payment succeded",
      "message": "Card transaction was completed succesfully"
    },
    "wrongPasswordError": {
      "title": "Wrong password",
      "message": "That email is already used but the password is incorrect please use the right password or change the email address to register in this event"
    },
    "registerSuccess": {
      "title": "Data registered",
      "message": "Participant's data was succesfully registered to the event:"
    },
    "registerSuccessUser": {
      "title": "Account created",
      "message": "The account has been created successfully."
    },
    "selectTicketTypeError": {
      "title": "Error selecting ticket",
      "message": "It was not possible to select a new ticket"
    },
    "fileError": {
      "title": "Error",
      "message": "Error processing file"
    },
    "formComplete": {
      "title": "Required fields",
      "message": "Fields form is required"
    },
    "ticketSelect": {
      "title": "Required ticket",
      "message": "Select one ticket"
    }
  },
  "recoveryPassword": {
    "title": "Login",
    "subtitle": "Forgot your password?",
    "description": "Enter your registered email and we’ll send a link to reset your password.",
    "emailLabel": "Email",
    "resetPasswordButton": "RESET MY PASSWORD",
    "resetPassword": "RESET PASSWORD",
    "recoverySuccess": {
      "title": "Success",
      "message": "Reset email password sent."
    },
    "erorCodeTitle": "Error to reset password",
    "erorCode": "Error in",
    "success": "Success reset",
    "successDescription": "Password was reset successfully",
    "erorConfirmTitle": "Password Confirm Error",
    "erorConfirm": "Passwords do not match",
    "successConfirmTitle": "Password Confirm Successful",
    "succesConfirm": "Passwords match"
  },
  "accountSettings": {
    "accountSettings": "Account Settings",
    "profile": "Profile",
    "resetPassword": "Reset password",
    "name": "Name",
    "fullName": "Full name",
    "firstName": "First name",
    "lastName": "Last name",
    "secondLastName": "Second Last name",
    "mail": "E-mail",
    "edit": "EDIT",
    "cancel": "CANCEL",
    "save": "SAVE",
    "phoneNumber": "Phone number",
    "address": "Address",
    "description": "Description",
    "email": "Email",
    "rules": {
      "name": "Please input a name",
      "lastName": "Please input a last name",
      "secondLastName": "Please input a second last name",
      "phoneNumber": "Please input a phone number",
      "phoneNumberLength": "Please input 10 digits",
      "phoneNumberOnlyDigits": "Please input only digits",
      "address": "Please input an address",
      "description": "Please input a description"
    },
    "updateSuccess": {
      "title": "Success",
      "message": "Your data has been updated."
    },
    "updateError": {
      "title": "Error",
      "message": "It was not possible updated your data."
    },
    "updateImageSuccess": {
      "title": "Success",
      "message": "Your profile image has been updated."
    },
    "updateImageError": {
      "title": "Error",
      "message": "It was not possible updated your profile image."
    }
  },
  "welcomeMessage": {
    "title": "Welcome Message",
    "seeMore": "See more",
    "greeting": "Dear colleagues and friends:",
    "aboutEvent": "About the event"
  },
  "footer": {
    "eventLocation": "Event Location",
    "contactUs": "Contact Us",
    "email": "Email: ",
    "phone": "Phone: ",
    "privacyPolicy": "Privacy Policy",
    "registrationCancellationPolicy": "Registration Policies",
    "bookingCancellationPolicy": "Booking Policies",
    "poweredBy": "Powered by"
  },
  "abstractsFound": "No call has been published yet",
  "hotels": {
    "hotelSelector": "Hotel",
    "hotelsAvailable": "Available Hotels",
    "hotelBooking": "Hotel Booking",
    "hotelAddress": "Address",
    "hotelDescription": "Description",
    "hotelCommodities": "Commodities",
    "allInclusive": "All Inclusive",
    "complimentaryBreakfast": "Complimentary Breakfast",
    "airConditioning": "Air Conditioning",
    "freeWifi": "Free Wifi",
    "fitnessCenter": "Fitness Center",
    "parking": "Parking",
    "rules": "Rules",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "rooms": "Rooms",
    "hotel": "hotel",
    "from": "from",
    "night": "night",
    "pickDate": "Pick a day",
    "guests": "Guests",
    "adults": "Adult(s)",
    "kid": "Kid(s)",
    "checkAvailability": "Check availability",
    "infoMessage": {
      "title": "Info message",
      "infoMessageCalendar": "The following calendar is only demonstrative and shows the dates on which the hotel will be available. However, no selection is possible"
    },
    "obtainHotelInfoError": {
      "title": "Error obtaining hotel information",
      "message": "It was not possible to obtain the hotel's information"
    },
    "errorAvailability": {
      "title": "Error to check the availability",
      "message": "It was not possible to check the availability"
    },
    "errorSaveBooking": {
      "title": "Error to save the booking",
      "message": "It was not possible to save the booking"
    },
    "errorAddBooking": {
      "title": "Error to add the booking",
      "message": "It was not possible to add the booking"
    },
    "errorPayBooking": {
      "title": "Error with the payment",
      "message": "It was not possible make the payment"
    },
    "room": {
      "roomDescription": "Description",
      "price": "Price",
      "perNight": "/night",
      "taxesNotIncluded": "(Taxes not included)",
      "roomCommodities": "Commodities",
      "additionalInfo": "Additional Information",
      "makeReservation": "Make a reservation",
      "datesAvailable": "Dates available",
      "obtainRoomInfoError": {
        "title": "Error obtaining room information",
        "message": "It was not possible to obtain the room's information"
      }
    },
    "book": "Book",
    "availableSearch": "Available for your Search",
    "forOnly": "From",
    "availableValidate": "There are no rooms available for the selected dates",
    "bookingCheckout": {
      "hotelBooking": "HOTEL BOOKING",
      "payment": "Payment",
      "checkIn": "Check In",
      "checkOut": "Check Out",
      "nights": "nights",
      "rooms": "rooms",
      "averageRate": "Average nightly rate",
      "taxes": "Taxes",
      "taxesFees": "Taxes and fees",
      "subtotal": "Subtotal",
      "IVA": "IVA",
      "includingTaxes": "Including taxes and fees",
      "pay": "Pay",
      "for": "For",
      "guest": "guest",
      "additionalComments": "Additional comments",
      "additionalFields": "Additional fields",
      "addCompanion": "Add companion",
      "guestInformation": "Guest information",
      "myBooking": "My booking",
      "paymentMethod": "Payment method",
      "rules": {
        "email": "Email is required"
      }
    }
  },
  "bookings": {
    "title": "HOTEL BOOKING",
    "subtitle": "My Bookings",
    "currentBookings": "Current Bookings",
    "bookingID": "Booking ID:",
    "roomCapacity": "Room capacity",
    "bedType": "Bed type",
    "capacityAdults": "adults",
    "capacityChildren": "children",
    "bookingDate": "Booking date",
    "contactUs": "Problems? Contact us",
    "hotelName": "Hotel name",
    "additionalComments": "Additional comments",
    "active": "Active",
    "canceled": "Cancelled",
    "status": "Status",
    "bookingStatus": {
      "paid": "Paid",
      "cancelled": "Cancelled",
      "pending": "Pending"
    }
  },
  "coupon": {
    "couponTitle": "Apply coupon!",
    "coupon": "Do you have a coupon? Please apply it below!",
    "apply": "Apply",
    "applyCoupon": "Apply Coupon!",
    "haveCoupon": "Do you have a coupon? Please apply it below!",
    "input": "Coupon Code",
    "noExist": "Invalid coupon",
    "noExistDetail": "The coupon is not valid",
    "validCoupon": "Valid coupon",
    "invalidCoupon": "Invalid coupon",
    "validCouponDetail": "The coupon was applied correctly",
    "invalidCouponDetail": "The coupon has expired or has exceeded the usage limit",
    "errorCoupon": "Error",
    "errorCouponDetail": "Failed to apply the coupon"
  },
  "reservationDetails": {
    "hotelBooking": "HOTEL BOOKING",
    "yourReservations": "Your reservations",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "adult": "Adult",
    "child": "Child",
    "night": "Nights",
    "room": "Room",
    "rooms": "Rooms",
    "price": "Price",
    "taxesNotIncluded": "taxes not included",
    "hintTaxes": "Taxes will be shown on checkout page",
    "goCheckout": "GO TO CHECKOUT"
  },
  "expo": {
    "downloadPicture": "Download image",
    "notFound": "No attachments found"
  },
  "speakers": {
    "main": "Main Speakers",
    "title": "Speakers",
    "notFound": "Speakers not found",
    "loading": "Loading Speakers",
    "viewMore": "View more"
  },
  "sponsors": {
    "title": "Official Sponsors",
    "platinum": "Platinum",
    "gold": "Gold",
    "silver": "Silver",
    "obtainSponsorsInfoError": {
      "title": "Error obtaining sponsors information",
      "message": "It was not possible to obtain the sponsors information"
    }
  },
  "program": {
    "fullProgram": "See full program",
    "title": "Program",
    "events": "Events",
    "program": "Program",
    "day": "Day",
    "register": "Register to this activity",
    "btnDownload": "Download program",
    "messages": {
      "getProgramErrorTitle": "Something went wrong!",
      "getProgramErrorMessage": "We're sorry! We could't get program data at the moment. Please try again later."
    },
    "warning": "Warning",
    "cancel": "Cancel",
    "continue": "Continue",
    "message": "The selected event is currently in progress, do you want to continue with the payment?.",
    "registerCourse": {
      "register": "Register",
      "coursePayment": "Course payment",
      "course": "Course",
      "speaker": "Speaker",
      "description": "Description",
      "startDate": "Start date",
      "endDate": "End date",
      "from": "From",
      "to": "to",
      "pay": "Pay",
      "courseDates": "Scheduled Dates",
      "date": "Date",
      "hours": "Hour",
      "registerSuccess": {
        "title": "Success",
        "message": "Successfully registered to the course"
      },
      "registerError": {
        "title": "Something went wrong",
        "message": "It wasn't possible to register to the course"
      },
      "alreadyRegisteredError": {
        "title": "Already registered",
        "message": "You have already registered to the course"
      },
      "soldOutError": {
        "title": "Sold out",
        "message": "The quota has been sold out"
      }
    },
    "courses": {
      "courses": "Courses",
      "coursesAndCertificates": "Courses & Certificates",
      "courseDate": "Course date",
      "startDate": "Start date",
      "endDate": "End date",
      "streamingURL": "Streaming URL",
      "evaluate": "Evaluate",
      "downloadCertificate": "Download certificate",
      "cost": "Cost",
      "freeCourse": "Free course",
      "eventDate": "Event date",
      "certificateNotAvailable": "Certificate not available",
      "eventEntry": "Event entry",
      "errorCheckEntranceEventMessage": {
        "title": "Error to check entrance record",
        "message": "Sorry, it has not been check the event entry"
      },
      "errorDownloadCertificate": {
        "title": "Certificate not available",
        "message": "Sorry,  it was not possible to download the certificate"
      }
    }
  },
  "participant": {
    "messages": {
      "getParticipantErrorTitle": "Failed to get participant!",
      "getParticipantErrorMessage": "We're sorry! The participant your search couldn't be found!"
    }
  },
  "abstract": {
    "abstractTitle": "Abstracts",
    "apply": "Apply",
    "mainAuthor": "Main Author",
    "coAuthors": "Co-Authors",
    "abstract": "Abstract",
    "fullName": "Full Name",
    "institution": "Institution",
    "coName": "Name(s)",
    "coLastName": "Lastname(s)",
    "coCountry": "Country & State",
    "coCity": "City",
    "title": "Title",
    "format": "Format in which you wish to present your work",
    "summary": "Summary and Objectives",
    "method": "Material and Methods",
    "result": "Results",
    "discussion": "Discussion",
    "conclusion": "Conclusions",
    "bibliography": "Bibliography",
    "validateForm": "Button disabled, please fill all the required fields",
    "validateFormCo": "Button activated, remember to click to save",
    "verLogin": "Verify that you have started the session",
    "verRegistro": "Register to the event",
    "verPay": "Complete the payment",
    "message": "The functionality of this window cannot be performed for one(s) of the following reasons:",
    "send": "Send",
    "support": "Inline PDFs are not supported by this browser",
    "download": "Download",
    "pdfInstructions": "Upload your document, it only accepts files of type; .pdf",
    "titleCoAuthores": "Co-Author #",
    "nameFileDefault": "No file chosen",
    "fileDefault": "Select File",
    "solicitudSuccess": {
      "title": "Registered request",
      "message": "Request was successfully registered to event:"
    },
    "solicitudError": {
      "title": "Something went wrong",
      "message": "The request could not be made"
    }
  },
  "dialogContinuePay": {
    "title": "Payment Required",
    "message": "Dear user, we inform you that your payment for the event has not yet been made. Remember that to have access to the special services of the event it is necessary to complete this process. We invite you to catch up on your payment by going to checkout.",
    "logoutButton": "Logout",
    "checkoutButton": "Go to checkout"
  },
  "bottomNavigation": {
    "bookings": "Bookings",
    "courses": "Courses",
    "billing": "Billing"
  },
  "survey": {
    "title": "Survey"
  },
  "contactUsMessage": "Problems? Contact us",
  "promotionVideo": {
    "title": "Promotion Video",
    "supportError": "Your browser does not support the video tag"
  },
  "downloadQR": "Download QR",
  "billing": {
    "myAccount": "MY ACCOUNT",
    "billing": "Billing",
    "myPurchases": "My purchases",
    "eventEntry": "Event entry",
    "course": "Course",
    "hotel": "Hotel",
    "downloadReceipt": "Download Receipt",
    "downloadInvoice": "Download Invoice",
    "requestInvoice": "Request Invoice",
    "invoiceRequested": "Invoice Requested",
    "nofound": "No invoices found",
    "noMore": "No more invoices found",
    "load": "Load more",
    "formComplete": "Complete all the fields",
    "invoiceRequestedMore": "Your request is in process you’ll be able to download your invoice within 72 hrs.",
    "billingProcessing": "Data for requesting the invoice is being processed. Please wait a moment.",
    "rules": {
      "pName": "Participant name is required",
      "email": "Email is required",
      "socialR": "Business name is required",
      "RFC": "RFC is required",
      "rfcLength": "RFC is required must be 13 digits",
      "direction": "Direction is required",
      "city": "City is required",
      "state": "State is required",
      "cp": "Postal code is required",
      "cpLength": "Postal code must be 5 digits",
      "fiscalR": "Tax regime is required",
      "CFDI": "Use of CFDI is required"
    },
    "form": {
      "pName": "Participant name",
      "email": "Email",
      "socialR": "Business name",
      "RFC": "",
      "direction": "Direction",
      "city": "City",
      "state": "State",
      "cp": "",
      "fiscalR": "Tax regime",
      "CFDI": "Use of CFDI",
      "send": "Send request"
    },
    "messages": {
      "errorGet": "Error get billings",
      "errorInvoice": "Error to request Invoice",
      "error": "Error in billing",
      "successRequest": "Billing requested",
      "successRequestMS": "Billing request successful"
    },
    "taxRegime": {
      "601": "General Legal Persons Law",
      "603": "Corporate Persons with Non-Profit Purposes",
      "605": "Wages and Salaries and Income Assimilated to Salaries",
      "606": "Lease",
      "607": "Disposal or Acquisition of Goods Regime",
      "608": "Other income",
      "610": "Residents Abroad without a Permanent Establishment in Mexico",
      "611": "Income from Dividends (partners and shareholders)",
      "612": "Individuals with Business and Professional Activities",
      "614": "Interest income",
      "615": "Regime for income from obtaining prizes",
      "616": "No tax obligations",
      "620": "Cooperative Production Companies that choose to defer their income",
      "621": "Fiscal Incorporation",
      "622": "Agricultural, Livestock, Forestry and Fishing Activities",
      "623": "Optional for Company Groups",
      "624": "Coordinated",
      "625": "Regime for Business Activities with income through Technological Platforms",
      "626": "Simplified Trust Regime"
    },
    "CFDI": {
      "G02": "Devoluciones, descuentos o bonificaciones.",
      "G03": "Gastos en general.",
      "D01": "Honorarios médicos, dentales y gastos hospitalarios.",
      "D04": "Donativos.",
      "D06": "Aportaciones voluntarias al SAR.",
      "D07": "Primas por seguros de gastos médicos.",
      "D10": "Pagos por servicios educativos (colegiaturas).",
      "S01": "Sin efectos fiscales.  ",
      "CP01": "Pagos",
      "CN01": "Nómina"
    }
  },
  "InstructionsCall": "For cancel your register to this event, call to: ",
  "Call": "Call",
  "cardRegister": {
    "register": "Please provide your information.",
    "description": "If you do not have an account you can add your information and continue",
    "errorPW": "The two passwords do not match",
    "save": "SAVE"
  }
}